// Helper to get nested value by key (supports dot notation)
export function getNestedValue(obj: unknown, key: string): unknown {
  return key
    .split(".")
    .reduce(
      (acc, part) =>
        acc && typeof acc === "object" && acc !== null && part in acc
          ? (acc as Record<string, unknown>)[part]
          : undefined,
      obj,
    );
}
